<template>
  <div class="commit-hash-container">
    <div> REDCAT-APP :  {{redcatAppHash}}</div>
    <div> auth :  {{auth}}</div>
    <div> data :  {{data}}</div>
    <div> form :  {{form}}</div>
    <div> process :  {{process}}</div>
    <div> mobile :  {{mobile}}</div>
    <div> shared :  {{shared}}</div>
    <div> excel :  {{excel}}</div>
    <div> system :  {{system}}</div>
    <div> router :  {{router}}</div>
    <div> cust :  {{cust}}</div>
    <div> task :  {{task}}</div>
    <div> trace :  {{trace}}</div>
    <div> openapi :  {{openapi}}</div>
  </div>
</template>

<script>
export default {
  name: 'commit-hash',
  data () {
    return {
      redcatAppHash: `${process.env.COMMIT_HASH}`,
      auth: '',
      data: '',
      form: '',
      process: '',
      mobile: '',
      shared: '',
      excel: '',
      system: '',
      router: '',
      cust: '',
      task: '',
      trace: '',
      openapi: ''
    }
  },
  methods: {
    getCommitHash (list = []) {
      list.forEach((value) => {
        this.$axios.get(`/${value}-api/commitHash`).then(res => {
          let hashCode = res.data ? String(res.data).replace('hash: ', '') : ''
          switch (value) {
            case 'auth':
              this.auth = hashCode
              break
            case 'data':
              this.data = hashCode
              break
            case 'form':
              this.form = hashCode
              break
            case 'process':
              this.process = hashCode
              break
            case 'mobile':
              this.mobile = hashCode
              break
            case 'shared':
              this.shared = hashCode
              break
            case 'excel':
              this.excel = hashCode
              break
            case 'system':
              this.system = hashCode
              break
            case 'router':
              this.router = hashCode
              break
            case 'cust':
              this.cust = hashCode
              break
            case 'task':
              this.task = hashCode
              break
            case 'trace':
              this.trace = hashCode
              break
            case 'openapi':
              this.openapi = hashCode
              break
          }
        })
      })
    }
  },
  created () {
    const list = [
      'auth',
      'data',
      'form',
      'process',
      'mobile',
      'shared',
      'excel',
      'system',
      'router',
      'cust',
      'task',
      'trace',
      'openapi'
    ]
    this.getCommitHash(list)
  }
}
</script>

<style lang="scss">
  .commit-hash-container {}
</style>



// WEBPACK FOOTER //
// src/components/system/commit-hash.vue